import React, { useRef, useState } from 'react';
import CompGridSupporters from '@components/grid/comp-grid-supporters.js';
import CompFormSupporters from '@components/form/comp-form-supporters.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {removeGrid} from '@assets/js/api/commonApi.js';

const SupportersMng = (props) => {
    /****************************
     * Define required variables
    *****************************/
    const childRef = useRef();
    const childGridRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);

    /**************************
     * Define button functions
    ***************************/
    const onNew = () => {
        childRef.current.modalToggle({mode: 'I'});
    }
    const onModify = (params) => {
        childRef.current.modalToggle({mode: 'M', ...params});
    }
    const onRemove = () => {
        if (selectedRows.length === 0) { alert('1건이상 선택해주세요.'); return; }
        const idsArray = [...selectedRows.ids];
        if (idsArray.length === 0) {
            alert('삭제할 항목을 선택해주세요.');
            return;
        }

        const deleteParams = {
            deleteList: idsArray.map(rowId => {
                const parts = rowId.split('-');
                return {
                    mngCd: parts[0],
                    supptsGrpCd: parts[1],
                    supptsCd: parts[2]
                };
            })
        };

        removeGrid('/sys/supptsmng/remove/info', deleteParams, {
            msg: {
                confirm: '선택된 ' + idsArray.length + '개 항목을 삭제하시겠습니까?',
            }
        }).then(res => {
            if (res && res.success) {
                //clear selected rows grid.
                setSelectedRows(new Set());
                onGridSearch();
            }
        });
    }
    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }
    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            supptsGrpNm : {
                id : 'supptsGrpNm',
                label : '서포터즈 그룹명',
                maxLength : 10
            },
            supptsNm : {
                id : 'supptsNm',
                label : '서보터즈 코드명',
                maxLength : 10
            },
        }
    }
    const buttonConfig = {
        leftButtons: [
            { id: 'new', label: 'New', className: 'btn-success', onClick: onNew },
            { id: 'remove', label: 'Remove', className: 'btn-danger', onClick: onRemove }
        ],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />
            
            {/* Grid */}
            <CompGridSupporters ref={childGridRef} onChildClick={onModify} onSelectionChange={setSelectedRows}/>

            {/* Modal popup */}
            <CompFormSupporters ref={childRef} onGridSearch={onGridSearch} />
        </> 
    );
}

export default SupportersMng;